import { Directive, ElementRef, OnInit, Input } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[check-compound]',
})
export class CheckCompoundDirective implements OnInit {
  @Input() url: string;

  constructor(private eltRef: ElementRef, private jwtHelper: JwtHelperService) {}

  ngOnInit() {
    const token = this.jwtHelper.tokenGetter();
    const isCompound = this.jwtHelper.decodeToken(token).i_com as string;

    if (isCompound === 'False' && this.url === '/citizens/compound-citizen') {
      const el: HTMLElement = this.eltRef.nativeElement;
      if (el.parentNode != null) {
        el.parentNode.removeChild(el);
      }
    }

    if (isCompound === 'True' && this.url === '/citizens/provider-citizens') {
      const el: HTMLElement = this.eltRef.nativeElement;
      if (el.parentNode != null) {
        el.parentNode.removeChild(el);
      }
    }
  }
}
